import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ContatosGestaoCobrancaDTO } from "types/dto/ContatosGestaoCobrancaDTO";
import { InformacoesUnidadeGestaoCobrancaDTO } from "types/dto/InformacoesUnidadeGestaoCobrancaDTO";

const onSuccess = (response: object, request: ContatosGestaoCobrancaDTO) => {
  const oldData = queryClient.getQueryData([
    "informacao-unidade",
    request.unidadeId,
  ]) as InformacoesUnidadeGestaoCobrancaDTO;

  queryClient.setQueryData(["informacao-unidade", request.unidadeId], {
    ...oldData,
    contato: request,
  });

  toast.success("Contato salvo com sucesso.");
};

const onError = () => {
  toast.error("Erro ao salvar contato.");
};

export const usePostInformacoesUnidade = () => {
  return usePost<ContatosGestaoCobrancaDTO>({
    url: api.gestaoCobranca.postAdicionarContatos,
    onSuccess,
    onError,
  });
};
